import config from 'constants/config'
import { EUROPE_REGIONS } from 'constants/config/region'
import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'
import { defineMessage } from 'react-intl'

export const followWhatsAppChannelMessage = defineMessage({
  id: 'gPqILuyVEfQ8vkgSFd1A',
  defaultMessage: 'Follow our WhatsApp Channel',
  description: 'Accessible name for links that open our WhatsApp Channel for exclusive offers, in the navigation bar and footer',
})

export function useWhatsAppChannelUrl(): string | undefined {
  const { currentRegionCode } = useContext(GeoContext)
  if (!config.WHATS_APP_CHANNEL_EUROPE_ENABLED || !EUROPE_REGIONS.has(currentRegionCode)) {
    return undefined
  }
  return config.WHATS_APP_CHANNEL_EUROPE_URL
}
